import React, { useState, useEffect } from 'react';
import Header from './components/Shared/Header/Header';

// Tabs
import CompanyOverview from "./components/CompanyOverview/CompanyOverview";
import FinancialPerformance from "./components/FinancialMetrics/FinancialPerformance";
import ValuationAnalysis from './components/ValuationAnalysis/ValuationAnalysis';
import AiInsights from './components/AiInsights/AiInsights';

function App() {
  const validTabs = ['companyOverview', 'financialMetrics', 'valuationAnalysis', 'aiInsights'];

  const [activeMetric, setActiveMetric] = useState(() => {
    const saved = localStorage.getItem('activeMetric');
    console.log("Loaded from localStorage:", saved);

    if (validTabs.includes(saved)) {
      return saved;
    } else {
      console.log("Invalid tab found in localStorage, resetting to companyOverview.");
      localStorage.setItem('activeMetric', 'companyOverview');
      return 'companyOverview';
    }
  });

  useEffect(() => {
    if (activeMetric) {
      console.log("Setting localStorage to:", activeMetric);
      localStorage.setItem('activeMetric', activeMetric);
    }
  }, [activeMetric]);

  return (
    <div className="min-h-screen bg-gray-50">
      <Header activeMetric={activeMetric} setActiveMetric={setActiveMetric} />

      <main className="max-w-7xl mx-auto px-4 py-8 sm:px-6 lg:px-8">
        {activeMetric === 'companyOverview' && <CompanyOverview />}
        {activeMetric === 'financialMetrics' && <FinancialPerformance />}
        {activeMetric === 'valuationAnalysis' && <ValuationAnalysis />}
        {activeMetric === 'aiInsights' && <AiInsights />}
      </main>
    </div>
  );
}

export default App;
